// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__38UfA","content":"LayoutSettings_content__2JlBP"};